var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "open-salud-about" },
    [
      _c(
        "v-row",
        { staticClass: "row container-assistance" },
        [
          _c(
            "v-col",
            {
              staticClass:
                "main-container-text px-lg-16 column-invert heightautos",
              attrs: { sm: "6" }
            },
            [
              _c("h3", { staticClass: "title-wellness-invert" }, [
                _vm._v(_vm._s(_vm.$t("secondblock.titleInvert")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subtitle-list subtitle-list mt-sm-5" },
                [
                  _c("div", { staticClass: "numericlist" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: {
                            textContent: _vm._s("mdi-numeric-1-circle-outline")
                          }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle1")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "itemslist" }, [
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "● " + _vm._s(_vm.$t("secondblock.firstlistitem1"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "● " + _vm._s(_vm.$t("secondblock.firstlistitem2"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "● " + _vm._s(_vm.$t("secondblock.firstlistitem3"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [_vm._v("● ...")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "numericlist" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: {
                            textContent: _vm._s("mdi-numeric-2-circle-outline")
                          }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle2")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "itemslist" }, [
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "● " + _vm._s(_vm.$t("secondblock.secondlistitem1"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "● " + _vm._s(_vm.$t("secondblock.secondlistitem2"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "● " + _vm._s(_vm.$t("secondblock.secondlistitem3"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [_vm._v("● ...")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "numericlist" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: {
                            textContent: _vm._s("mdi-numeric-3-circle-outline")
                          }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle3")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn1",
                          attrs: { white: "" },
                          on: {
                            click: function($event) {
                              return _vm.getWellness()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.button_text2) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "main-container-text px-lg-16 my-auto smallpadding",
              attrs: { sm: "6" }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "dietmargin",
                      attrs: { sm: "4", md: "4", lg: "4", xl: "4", cols: "12" }
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "boxshadowsmall" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", { staticClass: "title-diet" }, [
                              _vm._v(_vm._s(_vm.$t("secondblock.title-diet-1")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "subtitle-diet" }, [
                              _vm._v(
                                _vm._s(_vm.$t("secondblock.subtitle-diet-1"))
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "title-week", attrs: { cols: "12" } },
                        [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("secondblock.title-week-1")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "boxshadowsmalldiet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("secondblock.diet-1"))
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "subtitlediet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("secondblock.diet-subtitle-1")
                                )
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "asteriskdiet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {}, [
                              _vm._v(
                                _vm._s(_vm.$t("secondblock.asteriskdiet-1"))
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "dietmargin",
                      attrs: { sm: "4", md: "4", lg: "4", xl: "4", cols: "12" }
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "boxshadowsmall" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", { staticClass: "title-diet" }, [
                              _vm._v(_vm._s(_vm.$t("secondblock.title-diet-2")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "subtitle-diet" }, [
                              _vm._v(
                                _vm._s(_vm.$t("secondblock.subtitle-diet-2"))
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "title-week", attrs: { cols: "12" } },
                        [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("secondblock.title-week-2")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "boxshadowsmalldiet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("secondblock.diet-2"))
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "subtitlediet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("secondblock.diet-subtitle-2")
                                )
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "asteriskdiet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {}, [
                              _vm._v(
                                _vm._s(_vm.$t("secondblock.asteriskdiet-2"))
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      attrs: { sm: "4", md: "4", lg: "4", xl: "4", cols: "12" }
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "boxshadowsmall" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", { staticClass: "title-diet" }, [
                              _vm._v(_vm._s(_vm.$t("secondblock.title-diet-3")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "subtitle-diet" }, [
                              _vm._v(
                                _vm._s(_vm.$t("secondblock.subtitle-diet-3"))
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "title-week", attrs: { cols: "12" } },
                        [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("secondblock.title-week-3")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "boxshadowsmalldiet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("secondblock.diet-3"))
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "subtitlediet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("secondblock.diet-subtitle-3")
                                )
                              }
                            })
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { staticClass: "asteriskdiet" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("p", {}, [
                              _vm._v(
                                _vm._s(_vm.$t("secondblock.asteriskdiet-3"))
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d7feb30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7feb30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/PrimesaludWellnessSecondBlock.vue
// module id = 4028
// module chunks = 41